const getters = {
    userId: state => state.user.id,
    userName: state => state.user.name,
    userPicture: state => state.user.picture,
    userNick: state => state.user.nick,
    userRoles: state => state.user.roles,
}

export default getters;